// extracted by mini-css-extract-plugin
export default {"tx":"_077d950655","line":"_454429657f"};